import React from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from './Logo';
import AccountMenu from './AccountMenu';

export default function TopBar({ subtitle, subtitleSub, rightContent, showLive = false }) {
  const navigate = useNavigate();

  return (
    <header className="topbar">
      <button
        type="button"
        className="topbar-logo"
        onClick={() => navigate('/dashboard')}
        aria-label="SoKo Water Systems home"
      >
        <Logo variant="sokomark" width={100} />
      </button>

      <div className="topbar-right">
        {(subtitle || subtitleSub) && (
          <div className="topbar-subtitle">
            {subtitle && <div className="topbar-subtitle-main">{subtitle}</div>}
            {subtitleSub && <div className="topbar-subtitle-sub">{subtitleSub}</div>}
          </div>
        )}

        {showLive && (
          <div className="live-indicator">
            <div className="live-dot" />
            <span>Live</span>
          </div>
        )}

        {rightContent && <div className="topbar-extra">{rightContent}</div>}

        <AccountMenu variant="icon" />
      </div>
    </header>
  );
}
